export default "__VITE_ASSET__CjHJ5EVE__"